<div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
  <div>
    <h5 class="mb-1 fw-bold">Factories</h5>
    <span class="sub-text">Manage production factories</span>
  </div>
  <button class="btn btn-primary d-flex align-items-center gap-2" (click)="onAddFactory()">
    <i class="bi bi-plus-lg"></i>
    Add Factory
  </button>
</div>

@if (isDataLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  @if (factories.length === 0) {
    <app-info-alert>No factories found. Add your first factory to get started.</app-info-alert>
  } @else {
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="bg-light">
          <tr>
            <th class="border-0 text-uppercase small fw-bold text-muted py-3">Name</th>
            <th class="border-0 text-uppercase small fw-bold text-muted py-3">Address</th>
            <th class="border-0 text-uppercase small fw-bold text-muted py-3">Created</th>
            <th class="border-0 text-uppercase small fw-bold text-muted py-3 text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (factory of factories; track factory.id) {
            <tr>
              <td class="py-3 fw-semibold">
                <i class="bi bi-building me-2 text-primary"></i>
                {{ factory.name }}
              </td>
              <td class="py-3 text-muted small">{{ factory.address || '—' }}</td>
              <td class="py-3 text-muted small">{{ factory.created_at | date: 'mediumDate' }}</td>
              <td class="py-3 text-end">
                <div class="d-flex gap-2 justify-content-end">
                  <button class="btn btn-action-edit btn-sm" (click)="onEditFactory(factory)" title="Edit factory">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button
                    class="btn btn-action-delete btn-sm"
                    (click)="onDeleteFactory(factory)"
                    title="Delete factory">
                    <i class="bi bi-trash3"></i>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
}

<ng-template #factoryModal let-modal>
  <div class="modal-content border-0 shadow-lg">
    <form [formGroup]="factoryForm" (ngSubmit)="onSubmit()">
      <div class="modal-header py-3">
        <h5 class="modal-title">{{ isEditMode ? 'Edit Factory' : 'Add Factory' }}</h5>
        <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
      </div>

      <div class="modal-body p-4">
        @if (formError) {
          <app-error-alert [error]="formError" />
        }

        <div class="mb-3">
          <label class="form-label small fw-bold text-muted">
            Factory Name
            <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" formControlName="name" placeholder="e.g. Unit 1 - Main Plant" />
          @if (isInvalid('name')) {
            <div class="text-danger small mt-1">Factory name is required.</div>
          }
        </div>

        <div class="mb-3">
          <label class="form-label small fw-bold text-muted">Address</label>
          <textarea
            class="form-control"
            formControlName="address"
            rows="3"
            placeholder="Enter factory address..."></textarea>
        </div>
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="factoryForm.invalid || isSaving">
          @if (isSaving) {
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Saving...
          } @else {
            {{ isEditMode ? 'Update' : 'Create' }}
          }
        </button>
      </div>
    </form>
  </div>
</ng-template>
